export const trimStr = (input: string | null | undefined): string =>
  (typeof input === "string" ? input.trim() : "");
